
import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { NUMBER } from "../../../constants/app-constants";
import Slider from "@cars24/turbo-web/lib/slider";
import { SocialTestimonialCard } from "@cars24/turbo-web/lib/social-testimonial-card";
import styles from "./styles.css";
import { getDate } from "./selector";
import { yieldToMain } from "../../../utils/helpers/yield-to-main";
import { sendCustomGaEvents } from "../../../tracking";
import { pdiTestimonialSlideChanged } from "../../../constants/tracking-constants/pre-delivery-inspection";

const PreDeliveryInspectionTestimonials = ({ details }) => {

    const { title: testimonialTitle = "", sectionData: testimonialList = [] } = details || {};

    const handleSlideChange = async (e) => {
        const slideIndex = e && e.track && e.track.details && e.track.details.rel;
        await yieldToMain();
        sendCustomGaEvents({ ...pdiTestimonialSlideChanged, eventLabel: slideIndex });
    };

    return (
        <Fragment styleName={"styles.preDeliveryInspectionTestimonials"}>
            {testimonialList.length > NUMBER.ZERO &&
                <div styleName={"styles.testimonialWrapper"}>
                    <div>
                        <Slider gap={32} width="100%" height="100%" slideToShow={4} showDots={false} variant={"primary"} title={testimonialTitle} onSlideChange={handleSlideChange}>
                            {testimonialList.map(({ id: testimonialId = "", userDesignation = "", image = {}, title = "", description = "", publishedDate = "" }) => {
                                return (
                                    <SocialTestimonialCard
                                        key={testimonialId}
                                        profileHandle={userDesignation}
                                        profileImageUrl={image.url || ""}
                                        profileName={title}
                                        testimonial={description}
                                        dateValue={getDate(publishedDate)}
                                        isBackgroundColor={false}
                                        isBorder={true}
                                        profileImageLoading="lazy"
                                    />
                                );
                            }
                            )}
                        </Slider>
                    </div>
                </div>
            }
        </Fragment>
    );
};

PreDeliveryInspectionTestimonials.propTypes = {
    details: PropTypes.object
};

export default PreDeliveryInspectionTestimonials;
